import directInitReadingViewListeners, {initOnDemandReadingViewListeners} from "@/layouts/resources/reading";
import {registerDownloadFormListeners} from "@/layouts/resources/utils";
import resourceListingListeners from "@/layouts/resources/listing";

export * from './types';
export * from './utils';
export * from './listing';
export * from './reading';

export const initDocsResourcesListeners = () => {
    registerDownloadFormListeners();
    resourceListingListeners();
    directInitReadingViewListeners();
}

export const DocsResourcesUtils = {
    initOnDemandReadingViewListeners
}

export default initDocsResourcesListeners;